// Generated from CloudFormation stack davax-sam-dev; do not edit manually.
const config = {
  "branchName": "dev",
  "deploymentDate": "21/10/26",
  "deploymentTime": "14:38:35",
  "backendDeploymentAt": "2026-10-16T20:41:24.5470000Z",
  "aws": {
    "region": "us-east-1",
    "userPoolId": "us-east-1_n5Tp5dPdU",
    "userPoolWebClientId": "2sdmdbul303e8t2p5di369po7",
    "identityPoolId": "us-east-1:cb75a767-b7d0-4bba-aa92-5b01a14fef70",
    "apiEndpoint": "https://upx6adlrw5.execute-api.us-east-1.amazonaws.com/dev"
  },
  "frp": {
    "bindPort": 7000,
    "tunnelHost": "tunnel.dev.demo.davax-pc.com",
    "controlHost": "control.dev.demo.davax-pc.com",
    "cloudFrontDomain": "d36e2f1xvg7bey.cloudfront.net",
    "nlbDnsName": "davax-frp2-nlb-dev-5e2cc616ea3539c1.elb.us-east-1.amazonaws.com",
    "wildcardDemoDomain": "*.dev.demo.davax-pc.com",
    "httpVhostPort": 8080
  },
  "dynamodb": {
    "demoNodesTable": "davax-demo-nodes-dev",
    "demoSessionsTable": "davax-demo-sessions-dev"
  },
  "ec2": {
    "securityGroupId": "sg-03d72ea9ea8ddd5c7",
    "subnetIds": [
      "subnet-0eb311b42f33a6e2b",
      "subnet-0b199c4d4c1e0b46a"
    ],
    "launchTemplateId": "lt-0d8220454e16c2b24"
  }
};
export default config;
